// getRandomDelay et wait isolés
export const getRandomDelay = (min = 300, max = 800) =>
  Math.floor(Math.random() * (max - min) + min);

export const wait = (ms) => new Promise((res) => setTimeout(res, ms));
